import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

const tableList: ITkFakeTableLineProps[] = [
  {
    title: "メール種別",
    keyword: "emailClass",
    type: "text",
    text: "通知メール",
  },
  {
    title: "宛先",
    keyword: "mailAddress",
    type: "text",
  },
  {
    title: "タイトル",
    keyword: "title",
    requiredIcon: true,
    inputProps: { maxLength: 85 },
  },
  {
    title: "本文",
    keyword: "text",
    type: "textarea",
    requiredIcon: true,
    showLimit: true,
    rows: 20,
    inputProps: { maxLength: 1000 },
  },
];

const schema = {
  title: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    maxLength: {
      value: 85,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
    },
  },
  text: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    maxLength: {
      value: 1000,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "1000"),
    },
  },
};

export { tableList, schema };
